import { useWidget } from '@/state/WidgetContext';
import { useLocalization } from '@/hooks/useLocalization';
import LanguageSelector from '@/components/LanguageSelector/LanguageSelector';
import styles from '@/styles/forms.module.scss';

export default function LanguageScreen() {
  const { setLanguage, goToMenu } = useWidget();
  const { t } = useLocalization();

  const handleSelect = (code) => {
    setLanguage(code);
    goToMenu();
  };

  return (
    <div className={styles.languageScreen}>
      <div className={styles.languageTitle}>{t('language.selectPrompt')}</div>
      <LanguageSelector onSelect={handleSelect} />
    </div>
  );
}
